import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum FundOrderStatusesFormErrorStatesEnum {
    UpdateStatusFailed = ErrorStateScheduleEnum.TransactionStatusesFormErrorStatesStartIndex,
    UpdateStatusToCancelledRejected
}
